import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'apollo-react/components/Select';
import MenuItem from 'apollo-react/components/MenuItem';
import FieldWrapper from '../../fields/FieldWrapper';
import { DEFAULT_CURRENCIES } from '../constants/currencies';

const CurrencyFieldInput = ({
  id,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  options,
}) => {
  const { t } = useTranslation();

  const currencyOptions = useMemo(() => {
    if (options && options.length > 0) {
      return options;
    }
    return DEFAULT_CURRENCIES.map((c) => ({ value: c.code, label: c.label }));
  }, [options]);

  return (
    <FieldWrapper style={columnStyle}>
      <Select
        id={id}
        name={id}
        label={label}
        placeholder={placeholder || t('formRenderer.selectCurrency')}
        value={value || ''}
        onChange={onChange}
        onBlur={onBlur}
        helperText={helperText}
        error={showError}
        disabled={disabled}
        required={required}
        fullWidth
      >
        {currencyOptions.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FieldWrapper>
  );
};

export default CurrencyFieldInput;
